import moment from 'moment'
import MediaEntity, { IMediaProps } from './Media'
import { DownloadCreator } from '@/infrastructure/network/Monitaro/schema/models'

export interface IDownloadProps {
  id?: string
  creator?: DownloadCreator
  media: IMediaProps | null
  name: string | null
  code: string | null
  size: number | null
  category: string | null
  status: string | null
  createdAt: string | null
  updatedAt: string | null
}

export default class DownloadEntity {
  private _props: IDownloadProps

  constructor(props?: IDownloadProps | null) {
    this._props = EmptyDownloadPropsFactory(props)
  }

  get props(): IDownloadProps {
    return this._props
  }

  get clone(): IDownloadProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get creator(): DownloadCreator | undefined {
    return this._props.creator
  }

  get media(): MediaEntity {
    return new MediaEntity(this._props.media)
  }

  get name(): string | null {
    return this._props.name
  }

  get src(): string {
    return (process.env.ASSETS_URL || '') + this._props.name
  }

  get code(): string | null {
    return this._props.code
  }

  get size(): string {
    if (this._props.size) {
      const decimal = Math.pow(10, 0)
      const kiro = 1024
      let size = this._props.size
      let unit = 'B'
      const units = ['B', 'KB', 'MB', 'GB', 'TB']
      for (let i = units.length - 1; i > 0; i--) {
        if ((this._props.size || 0) / Math.pow(kiro, i) > 1) {
          size = Math.round(((this._props.size || 0) / Math.pow(kiro, i)) * decimal) / decimal
          unit = units[i]
          break
        }
      }
      return String(size) + unit
    }
    return ''
  }

  get category(): string | null {
    return categories.find((prop) => prop.value === this._props.category)?.text || null
  }

  get status(): string | null {
    return status.find((prop) => prop.value === this._props.status)?.text || null
  }

  get createdAt(): string | null {
    return this._props.createdAt ? moment(this._props.createdAt).format('YYYY/MM/DD HH:mm') : null
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [
  { text: 'データ種別', value: 'category' },
  { text: 'ステータス', value: 'status' },
  { text: 'サイズ', value: 'size' },
  { text: '文字コード', value: 'code' },
  { text: 'ダウンロード', value: 'name' },
  { text: '作成日', value: 'createdAt' }
]

export const categories = [
  { text: '担当リスト', value: 'User' },
  { text: '出入時刻', value: 'Admission' },
  { text: '訪問予定/結果', value: 'Schedule' },
  { text: '当院の未登録', value: 'Company' }
]

export const status = [
  { text: '完了', value: 'completed' },
  { text: '処理中', value: 'progress' },
  { text: '失敗', value: 'failed' }
]

export const EmptyDownloadPropsFactory = (props?: Partial<IDownloadProps> | null): IDownloadProps => ({
  media: null,
  name: null,
  code: 'SJIS-win',
  size: null,
  category: null,
  status: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
